<template>
    <div class="main">
        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell text-center">
                    <h1>Sneakers</h1>
                </div>
                <div class="small-12 cell">
                    <div class="callout large">
                        <h5>Looking for a sneaker?</h5>
                        <p>{{ searchResults }}</p>
                        <form @submit.prevent>
                            <input type="text" v-model="searchQuery" list="sneakers" required>
                            <select v-if="filteredSneaker != undefined" v-model="selected">
                                <option v-for="sneaker in filteredSneaker" :value="sneaker">{{ sneaker.model_name }}</option>
                            </select>
                            <button class="button" @click="goToSneaker()">Go to sneaker</button>
                        </form>
                    </div>
                </div>
                <div v-for="brand in brands" class="small-12 medium-6 large-4 cell">
                    <router-link :to="{ path: `/sneakers/${brand.name}` }" class="card">
                        <img :src="brand.hero_image_url" />
                        <div class="card-section">
                            <p class="lead">{{ brand.name }}</p>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Brands',
    data () {
        return {
            searchQuery: "",
            selected: "",
            foundSneakers: 0
        }
    },
    watch: {
        searchQuery: function () {
            this.selected = this.filteredSneaker[0]
        }
    },
    computed: {
        brands () {
            return this.$store.getters.loadedBrands
        },
        filteredSneaker () {
            if (this.searchQuery === "") return
            let query = this.searchQuery.toLowerCase().split(" ")
            return this.$store.getters.loadedSneakers.filter((sneaker) => {
                return query.every(function (value) {
                    return (sneaker.model_name.toLowerCase().indexOf(value) >= 0 && sneaker.image_url !== "");
                });
            }).slice(0, 10)
        },
        searchResults () {
            if (this.filteredSneaker == undefined) {
                return "Search for your favorite sneakers here." 
            } else if (this.filteredSneaker.length > 10) {
                return "We found more than 10 sneakers, if you didn't find what you were looking for, try more specific search criteria." 
            } else if (this.filteredSneaker.length == 0) {
                return "We could not find any sneakers matching these criteria."
            } else if (this.filteredSneaker.length == 1) {
                return "We found " + this.filteredSneaker.length + " sneaker matching your criteria."
            } else {
                return "We found " + this.filteredSneaker.length + " sneakers matching your criteria."
            }
        }
    },
    methods: {
        goToSneaker: function () {
            let brand = this.selected.brand
            let slug = this.selected.slug
            this.$router.push(`/sneakers/${brand}/${slug}`)
        }
    }
}
</script>
<style scoped>
.card, .callout {
    background-color: rgb(236, 236, 236)
}

.callout {
    margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// Sneakers.vue?ac268a9c